/**
 * Pure view-model for the toolbar popup auth gate (DOCK-12).
 *
 * Shared Dock-branded copy is also imported by the FAB login card so the two
 * surfaces cannot drift.
 */

export type PopupAuthView = 'loggedOut' | 'settings';

/** Dock-branded logged-out card copy (toolbar + FAB). */
export const DOCK_LOGGED_OUT_COPY = {
  title: 'Pearl',
  subtitle: 'Sign in to continue',
  cta: 'Log in',
} as const;

/**
 * @param auth - Result of CHECK_AUTH_CACHE (or equivalent).
 * @returns Which toolbar popup region to show.
 */
export function resolvePopupView(auth: {
  accessToken?: string | null;
}): PopupAuthView {
  return auth.accessToken ? 'settings' : 'loggedOut';
}

/**
 * Mic controls stay available whether or not the user is signed in.
 *
 * @param _view - Current popup auth view (unused; both show mic).
 * @returns Always true for the toolbar popup.
 */
export function shouldShowMic(_view: PopupAuthView): boolean {
  return true;
}
